import CityPageTemplate from "../city-template/CityPageTemplate";
import { colonialHeightsVaConfig } from "./data";

export default function ColonialHeightsVaPage() {
  return <CityPageTemplate config={colonialHeightsVaConfig} />;
}